import React, { Suspense } from 'react';
import { useWorldStore } from '../state/worldStore';
import AnimatedResident from './AnimatedResident';

// ConcertGuard — a rigged security guard standing (idle loop) out front of the
// concert hall on the street (?city=model). Anchored to the concert-hall venue
// building (venueAnchors), a few metres toward the approach. Dial the exact
// spot live: ?guardx / ?guardz (offset from the building) · ?guardrot (facing)
// · ?guardh (height). Or open ?guard=edit for the on-screen move panel.
// AnimatedResident scales-to-height and plays the GLB's own "idle" clip (no
// attentionRadius → none of the NPC proximity behaviour).
export default function ConcertGuard() {
  const venueAnchors = useWorldStore((s) => s.venueAnchors);
  const g = useWorldStore((s) => s.guardTune);
  const anchor = venueAnchors?.['concert-hall'];
  if (!anchor) return null;
  const [ax, , az] = anchor;
  return (
    <Suspense fallback={null}>
      <AnimatedResident
        meshUrl="/models/security_guard.glb"
        clipUrls={[]}
        play="idle"
        height={g.h}
        position={[ax + g.x, g.y, az + g.z]}
        rotationY={g.rot}
      />
    </Suspense>
  );
}
